const prefix = 'user-apply';

const SET_MANAGED_APPLY = `${prefix}/SET_MANAGED_APPLY`;

const SET_LOADING = `${prefix}/SET_LOADING`;

const RESET = `${prefix}/RESET`;

export { SET_MANAGED_APPLY, RESET, SET_LOADING };
